/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".address-container[_ngcontent-%COMP%]   .save-button[_ngcontent-%COMP%]{text-align:right}.address-container[_ngcontent-%COMP%]   .checkbox-container[_ngcontent-%COMP%]{font-weight:400;padding-top:20px;margin-bottom:35px}.address-container[_ngcontent-%COMP%]   .checkbox-container[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-weight:700}.address-container[_ngcontent-%COMP%]   .validation-msg[_ngcontent-%COMP%]{background-color:#ef080c;padding:16px;color:#fff;text-align:center;margin-bottom:30px;font-size:16px}"];
export { styles as styles };
